import React, { useState } from "react";
import ManifestFormActions from "components/ManifestFormActions";
import PublishActions from "components/PublishActions";
import HoverIconButton from "components/HoverIconButton";
import ManifestDestroyButton from "components/ManifestDestroyButton";
import InfoIcon from "components/InfoIcon";
import Pill from "components/Pill";
import { EDITOR_FIRST_TIME } from "constants/education";
import { useCtxReferences } from "utils/selectors";
import { STATUS, UI_THEME } from "utils/constants/ui";
import { APPLICATION_STATUS } from "utils/constants/application";
import { PILL_THEME } from "components/Pill";
import Link from "next/link";
import { useAppHubRoute } from "utils/hooks/hub";
import { HUB_APP_SUB_SECTION } from "utils/constants/navigation";
import { useFormikContext } from "formik";
import { STATE_KEYS } from "utils/constants/state";
import get from "lodash/get";
import isEmpty from "lodash/isEmpty";
import { useRouter } from "next/router";
import Modal from "components/Modal";
import ModalContent from "components/ModalContent";
import ModalActions from "components/ModalActions";
import { useIsMounted } from "utils/hooks";
import { AUTHED_DIRTY_BUILDER_FORM_CONFIRM } from "utils/constants/builder";

const MobileEditorHeader = ({ preview, publish, initialValues }) => {
  const [showModal, setShowModal] = useState(false);
  const isMounted = useIsMounted();
  const { application } = useCtxReferences();
  const appRoot = useAppHubRoute();
  const destination = `${appRoot}/${HUB_APP_SUB_SECTION.PAGES}`;
  const { values, touched } = useFormikContext();
  const router = useRouter();
  const uuid = get(values, STATE_KEYS.MANIFEST.UUID);
  const formIsDirty = !isEmpty(touched);

  /**
   * Show a confirmation modal if the form is dirty
   */
  let navBack;
  if (formIsDirty) {
    navBack = (
      <div
        className="flex flex-row items-center pointer flex-shrink-0"
        onClick={() => setShowModal(true)}
      >
        <HoverIconButton type="back" />
        <div className="f5 fw5">Back to hub</div>
      </div>
    );
  } else {
    navBack = (
      <Link href={destination}>
        <div className="flex flex-row items-center pointer flex-shrink-0">
          <HoverIconButton type="back" />
          <div className="f5 fw5">Back to hub</div>
        </div>
      </Link>
    );
  }

  return (
    <div className="w-100 bg-white db bb hairline-1 sticky top-0 z-6">
      <div className="db w-100 ph3 pt2">
        <div className="flex flex-row items-center justify-between pb2">
          {navBack}
          <div className="flex flex-row items-center">
            <InfoIcon uid={EDITOR_FIRST_TIME} />
          </div>
          {uuid && (
            <div className="flex flex-row pl3 h-100">
              <ManifestDestroyButton
                uuid={uuid}
                afterDestroy={() => router.replace(destination)}
              />
            </div>
          )}
        </div>
      </div>
      <div className="pv2 bt hairline-1 ph3">
        {application && application.status === APPLICATION_STATUS.SUSPENDED ? (
          <Pill
            copy="Application Suspended"
            theme={PILL_THEME.SLIM}
            status={STATUS.DANGER}
          />
        ) : (
          <div className="flex flex-row items-center justify-between">
            <div className="flex flex-row">
              <ManifestFormActions
                theme={UI_THEME.SLIM}
                initialValues={initialValues}
              />
            </div>
            <div className="flex flex-row">
              <PublishActions preview={preview} publish={publish} />
            </div>
          </div>
        )}
      </div>
      {showModal && (
        <Modal showModal={showModal} onClose={() => setShowModal(false)}>
          <ModalContent slides={AUTHED_DIRTY_BUILDER_FORM_CONFIRM}>
            {() => (
              <div className="w-100 pa3">
                <ModalActions
                  actions={[
                    {
                      cta: "Cancel",
                      onClick: () => {
                        setShowModal(false);
                      }
                    },
                    {
                      cta: "Yes",
                      onClick: () => {
                        router.push(destination);
                        if (isMounted.current) {
                          setShowModal(false);
                        }
                      }
                    }
                  ]}
                />
              </div>
            )}
          </ModalContent>
        </Modal>
      )}
    </div>
  );
};

export default MobileEditorHeader;
